import Requests from "@/services/Requests";

const state = {
  limit: 50,
  employees: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allEmployees: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  employeeById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of employees based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter employees by. Defaults to 0.
   * @return {Array} An array of employees filtered by the given page number. If page is 0, returns all employees.
   */
  getEmployees:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.employees.data
        : state.employees.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllEmployees: (state) => state.allEmployees.data,
  getEmployeeLimit: (state) => state.limit,
  getEmployeeStatus: (state) => state.employees.status,
  getEmployeeCount: (state) => state.employees.count,
  getEmployeePage: (state) => state.employees.page,
  getEmployeePages: (state) => Math.ceil(state.employees.count / state.limit),
  getEmployeesLoading: (state) => state.employees.status === "loading",
  getEmployeeById: (state) => (id) =>
    state.employeeById.data.find((d) => d.id === id) || {},
  getEmployeeLoadingById: (state) => state.employeeById.status === "loading",
};
const mutations = {
  /**
   * Updates the status of the employee in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the employee.
   */
  SET_EMPLOYEE_STATUS(state, payload) {
    console.log(state.employees, "status: ", payload);
    state.employees.status = payload;
  },
  /**
   * Sets the employees and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of employees.
   * @param {number} payload.count - The total count of employees.
   */
  SET_EMPLOYEES(state, payload) {
    state.employees.data = payload.items;
    state.employees.count = payload.count;
  },
  /**
   * Sets the employees and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of employees.
   * @param {number} payload.count - The total count of employees.
   */
  SET_ALL_EMPLOYEES(state, payload) {
    console.log("SET_ALL_EMPLOYEES", payload);
    state.allEmployees.data = payload.items;
    state.allEmployees.count = payload.count;
  },
  /**
   * Updates the status of the update employee in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the employee.
   */
  SET_UPDATE_EMPLOYEE_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an employee object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated employee object.
   * @return {void}
   */
  SET_UPDATE_EMPLOYEE(state, payload) {
    const index = state.employees.data.findIndex((d) => d.id === payload.id);
    console.log(index, "index", payload, "payload");
    const indexById = state.employeeById.data.findIndex(
      (d) => d.id === payload.id
    );
    if (index !== -1) {
      const employee = state.employees.data[index];
      state.employees.data[index] = { ...employee, ...payload };
    }
    if (indexById !== -1) {
      const employeeById = state.employeeById.data[indexById];
      state.employeeById.data[indexById] = { ...employeeById, ...payload };
    }
  },
  SET_CREATE_EMPLOYEE_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new employee to the list of employees in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The employee object to be added.
   * @return {void}
   */
  SET_CREATE_EMPLOYEE(state, payload) {
    state.employees.data.push(payload);
  },
  /**
   * Updates the status of the delete employee in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the employee.
   */
  SET_DELETE_EMPLOYEE_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an employee from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the employee ID to be deleted.
   * @param {number} payload.id - The ID of the employee to be deleted.
   * @return {void}
   */
  SET_DELETE_EMPLOYEE(state, payload) {
    state.employees.data = state.employees.data.filter(
      (d) => d.id !== payload.id
    );
  },
  SET_EMPLOYEE_BY_ID_STATUS(state, payload) {
    state.employeeById.status = payload;
  },
  SET_EMPLOYEE_BY_ID(state, payload) {
    state.employeeById.data.push(payload);
  },
  SET_EMPLOYEE_LIVE_LOCATION(state, payload) {
    const updater = (employee) => {
      if (!employee || employee.id !== payload.id) return employee;
      return {
        ...employee,
        latitude: payload.latitude,
        longitude: payload.longitude,
        lastLocationDatetime: payload.lastLocationDatetime,
      };
    };

    state.employees.data = state.employees.data.map(updater);
    state.allEmployees.data = state.allEmployees.data.map(updater);
    state.employeeById.data = state.employeeById.data.map(updater);
  },
};

const actions = {
  /**
   * Retrieves a list of employees based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.searchKey - The search key.
   * @param {string} payload.query.regionId - The region ID.
   * @param {string} payload.query.companyId - The company ID.
   * @param {number} payload.query.page - The page number.
   * @return {Promise<void>}
   */
  async getEmployees({ state, commit }, payload) {
    // if query param is not in payload or if there is already data with same page number, don't fetch again
    if (
      !["searchKey", "regionId", "companyId"].some(
        (key) => payload.query[key]
      ) &&
      state.employees.data.filter(
        (employee) => employee.page === payload.query.page
      ).length > 0 &&
      !payload.force
    )
      return;
    const status = payload.force ? "unitiliazed" : state.employees.status;
    commit("SET_EMPLOYEE_STATUS", "loading");
    const response = await Requests.Employee.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_EMPLOYEES", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page,
        })),
        count: response.data.count,
      });
      console.log(payload, "payload", payload.initial, "inital");
      if (status === "unitiliazed")
        commit("SET_ALL_EMPLOYEES", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page,
          })),
          count: response.data.count,
        });
    }
    commit("SET_EMPLOYEE_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an employee by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the employee data.
   * @param {string} payload.fullName - The full name of the employee.
   * @param {string} payload.phoneNumber - The phone number of the employee.
   * @param {string} payload.email - The email of the employee.
   * @param {string} payload.regionId - The ID of the region the employee belongs to.
   * @param {File} payload.image - The image of the employee.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createEmployee({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.Employee.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_EMPLOYEE", {
          id: response.data,
          fullName: payload.fullName,
          phoneNumber: payload.phoneNumber,
          email: payload.email,
          regionId: payload.regionId,
          image: payload.image,
          workStartTime: payload.workStartTime,
          workEndTime: payload.workEndTime,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an employee by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the employee data to update.
   * @param {string} payload.fullName - The full name of the employee.
   * @param {string} payload.phoneNumber - The phone number of the employee.
   * @param {string} payload.email - The email of the employee.
   * @param {string} payload.regionId - The ID of the region the employee belongs to.
   * @param {File} payload.image - The image of the employee.
   * @param {number} payload.workStartTime - The start time of the work day.
   * @param {number} payload.workEndTime - The end time of the work day.
   * @param {boolean} payload.isActive - Whether the employee is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateEmployee({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.Employee.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_EMPLOYEE", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an employee from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the employee data.
   * @param {number} payload.id - The ID of the employee to be removed.
   * @returns {Promise<void>} A promise that resolves when the employee is successfully removed.
   */
  removeEmployee({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.Employee.Delete({ params: { id } })
      .then((response) => {
        const result = response.message === "OK" ? "OK" : "error";
        state.deleteStatus = result;
        return result;
      })
      .catch(() => {
        const result = "error";
        state.deleteStatus = result;
        return result;
      });
  },
  /**
   * Retrieves an employee by their ID and updates the employee by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the employee to retrieve.
   * @return {Promise} A promise that resolves when the employee is successfully retrieved and the status is updated.
   */
  getEmployeeById({ commit, state }, { id, force }) {
    // check if employee already exists in the state;
    if (
      state.employeeById.data.find((employee) => employee.id === id) &&
      !force
    )
      return state.employeeById.data.find((employee) => employee.id === id);

    commit("SET_EMPLOYEE_BY_ID_STATUS", "loading");
    return Requests.Employee.GetById({ params: { id } })
      .then((response) => {
        commit("SET_EMPLOYEE_BY_ID", response.data);
        commit("SET_EMPLOYEE_BY_ID_STATUS", "success");
        return response.data;
      })
      .catch(() => {
        commit("SET_EMPLOYEE_BY_ID_STATUS", "error");
        return {};
      });
  },
  updateEmployeeLiveLocation({ commit }, payload) {
    commit("SET_EMPLOYEE_LIVE_LOCATION", payload);
  },
};

export default { state, getters, mutations, actions };
